module.exports = __webpack_public_path__ + "media/mypage/images/banner_interviews_pc-ca0de570d5a3bd417d484bb422b559ec.png";